import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { axiosNewInstance } from "../../config/Api";
import { useSelector } from "react-redux";
import LangData from "../common/LangData";
import "./DashboardHome.css";
import { FaUsers, FaCartPlus, FaUserCircle, FaBriefcase, FaHistory, FaPercentage, FaChartLine } from "react-icons/fa";
import { BiBorderRadius } from "react-icons/bi";
import { VscSettings } from "react-icons/vsc";
import { CgProfile } from "react-icons/cg";

const DashboardHome = ({ setActiveItem }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const token = localStorage.getItem("authToken");

  const user = useSelector((state) => state?.user);
  const userType = user?.loginuser?.user_type;
  const roleId = Number(user?.loginuser?.role_id);
  const isAdmin = roleId === 1;
  const canSeeCustomerDetails = roleId === 5 || roleId === 4 || roleId === 2;
  const canSeeAgencyAndCommission = roleId === 2 || roleId === 4;

  // Define shortcut cards based on the same logic as the sidebar menu
  const shortcutCards = [
    { name: "User", icon: <FaUsers size={40} />, translationKey: "label_user", descriptionKey: "desc_user" },
    { name: "Role", icon: <BiBorderRadius size={40} />, translationKey: "label_role", descriptionKey: "desc_role" },
    { name: "Permission", icon: <VscSettings size={40} />, translationKey: "label_permission", descriptionKey: "desc_permission" },
    { name: "Profile", icon: <CgProfile size={40} />, translationKey: "label_profile", descriptionKey: "desc_profile" },
    { name: "Policy Application", icon: <FaCartPlus size={40} />, translationKey: "label_policy_application", descriptionKey: "desc_policy_application" },
    { name: "Customer Details", icon: <FaUserCircle size={40} />, translationKey: "customer_details", descriptionKey: "desc_customer_details" },
    { name: "My Policies", icon: <FaBriefcase size={40} />, translationKey: "label_my_policies", descriptionKey: "desc_my_policies" },
    { name: "Commission Details", icon: <FaPercentage size={40} />, translationKey: "commission_details", descriptionKey: "desc_commission_details" },
    { name: "Agency Details", icon: <FaChartLine size={40} />, translationKey: "agency_details", descriptionKey: "desc_agency_details" },
    { name: "Premium History", icon: <FaHistory size={40} />, translationKey: "premium_history", descriptionKey: "desc_premium_history" },
    { name: "Business Details", icon: <FaBriefcase size={40} />, translationKey: "business_details", descriptionKey: "desc_business_details" },
  ];

  // Filter based on actual sidebar logic
  const filteredCards = shortcutCards.filter((card) =>
    userType === "Customer" || roleId === 5
      ? card.name === "Profile" || card.name === "Policy Application" || card.name === "Customer Details" || card.name === "Premium History"
      : card.name === "Profile"
      || ((card.name === "User" || card.name === "Role" || card.name === "Permission") && isAdmin)
      || ((card.name === "Customer Details" || card.name === "Premium History") && canSeeCustomerDetails)
      || (card.name === "My Policies" && roleId === 2)
      || ((card.name === "Agency Details" || card.name === "Commission Details") && canSeeAgencyAndCommission)
      || (card.name === "Policy Application")
      || (card.name === "Business Details" && (roleId === 2 || roleId === 6 || roleId === 7 || roleId === 8 || roleId === 9))
  );

  const handleCardClick = (target) => {
    let activeTarget = target;
    if (target === "Business Details") {
      if (roleId === 2 || roleId === 8 || roleId === 9) {
        activeTarget = "Branch";
      } else if (roleId === 6 || roleId === 7) {
        activeTarget = "My Details";
      }
    }
    setActiveItem(activeTarget);
    localStorage.setItem("activeItem", activeTarget);
  };

  return (
    <div className="container dashboard_home_container py-4">
      <div className="row mb-4">
        <div className="col-12">
          <h2 className="font-weight-bold mb-4" style={{ color: "#011e36" }}>
            <LangData keyname="label_dashboard" />
          </h2>
          <h5 className="text-muted mb-4">
            <LangData keyname="label_welcome_dashboard" />
          </h5>
        </div>
      </div>

      <div className="row">
        {filteredCards.map((card) => (
          <div key={card.name} className="col-md-4 col-sm-6 mb-4">
            <div
              className="card border-0 shadow-sm shortcut-card h-100"
              onClick={() => handleCardClick(card.name)}
              style={{ cursor: "pointer", transition: "transform 0.2s" }}
            >
              <div className="card-body d-flex flex-column align-items-center justify-content-center p-5">
                <div className="shortcut-icon-container text-primary mb-4">
                  {card.icon}
                </div>
                <h4 className="card-title font-weight-bold mb-2">
                  <LangData keyname={card.translationKey} />
                </h4>
                <p className="card-text text-center text-muted small">
                  <LangData keyname={card.descriptionKey} />
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardHome;
